import src from "IMAGE";
export default { src, width: 450, height: 375, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAASElEQVR42pWNwQrAMAhD/fviRfDidzgVBN3HrWvPG/RdEkhC4P4A/oKIuBZmtk1VQWYS0RgDEacREWZ2d+juKaq6u7F4F8fnD4HVdn5t4fxLAAAAAElFTkSuQmCC"};
